'use client';

import type React from 'react';
import { financingTrack, homeProject } from '~/constants/eventable';
import AnalyticsProvider from '~/context/common/AnalyticsProvider';
import { ModalContextProvider } from '~/context/flp/ModalContext';

export type OwnProps = React.PropsWithChildren<{
  correlationId: string;
}>;

export default function FinancingProviders({
  children,
  correlationId
}: OwnProps) {
  return (
    <AnalyticsProvider
      correlationId={correlationId}
      projectName={homeProject}
      track={financingTrack}
    >
      <ModalContextProvider>{children}</ModalContextProvider>
    </AnalyticsProvider>
  );
}
